import React from 'react'

export const addSVG = <svg className="addSVG" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 14 14" enableBackground="new 0 0 14 14;" xmlSpace="preserve">
   <g id="Group_4485" transform="translate(-4703 1786)">
   	<path id="Path_1521" className="st0" d="M4713.7-1778.1h-3v3.2h-1.5v-3.2h-3v-1.6h3v-3.2h1.5v3.2h3V-1778.1z"/>
   </g>
</svg>

export const markInCallSVG = <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 8 16" enableBackground="new 0 0 8 16;" xmlSpace="preserve">
<g id="Group_2743" transform="translate(2886.486 -140.956)">
	<g transform="matrix(1, 0, 0, 1, -2886.49, 140.96)">
		<path id="Path_634-2" className="st0" d="M8,7.2L4,12L0,7.2V0h8L8,7.2z"/>
	</g>
</g>
<rect id="Rectangle_785" x="3" y="13" className="st0" width="2" height="3"/>
</svg>

export const moveRecord = <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 12 12" enableBackground="new 0 0 12 12" xmlSpace="preserve">
<g id="Group_2810" transform="translate(7975 1320)">
<g id="Group_2680">
   <path id="Path_1199" fill="#FFFFFF" d="M-7965-1317.9l-5.6,4l5.6,4V-1317.9z M-7972.9-1310h1.3v-8h-1.3V-1310z"/>
</g>
</g>
</svg>

export const playRecord = <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
xmlSpace="preserve">
<g className="ButtonPlayCallLog" id="Group_2675_2_">
<g id="Group_2674_2_">
   <path id="Path_1194_2_" fill="#FFFFFF" d="M7,18.4l12-9l-12-9V18.4z"/>
</g>
</g>
</svg>

export const pause = <svg className="ButtonPauseCallLog" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
 xmlSpace="preserve">
	<path  fill="#FFFFFF" d="M3.6,16.4h4v-14h-4V16.4z M11.6,2.4v14h4v-14H11.6z"/>
</svg>

export const markSvg = <svg version="1.1" className="iconBarCall" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="-4765 1782 22 22" enableBackground="new 0 0 40 40">
  <g id="Group_4484" data-name="Group 4484" transform="translate(-8196 384.85)">
    <path id="Path_634" data-name="Path 634" className="cls-1" d="M-7.924-7.964l-4.038,4.976L-16-7.964V-15.55h8.076Z" transform="translate(3454.028 1415.7)"/>
    <rect id="Rectangle_258" data-name="Rectangle 258" className="cls-1" width="14" height="2" transform="translate(3435 1414.131)"/>
  </g>
</svg>

export const callHistorySVG = <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="100%" height="100%" viewBox="0 0 40 40" enableBackground="new 0 0 40 40" xmlSpace="preserve">
<g>
	<linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="16.3633" y1="34.4092" x2="16.3633" y2="5.6772">
		<stop  offset="0" style={{stopColor:"#F2F2F2"}}/>
		<stop  offset="1" style={{stopColor:"#FFFFFF"}}/>
	</linearGradient>
	<path fill="url(#SVGID_1_)" d="M24.015,22.043c2.163-4.922,2.6-10.615,0.803-16.128c-0.228-0.702-0.995-1.09-1.701-0.863
		L18.61,6.495c-0.707,0.229-1.1,0.987-0.872,1.69l0.753,4.793c0.003,0.492,0.268,0.959,0.745,1.199l3.747,1.902
		c-0.678,4.206-2.703,8.113-5.742,11.133l-3.746-1.9c-0.459-0.233-1.012-0.183-1.412,0.112l-4.359,2.202
		c-0.706,0.227-1.098,0.987-0.87,1.689l1.451,4.458c0.229,0.7,0.996,1.091,1.702,0.863c4.332-1.388,7.957-3.935,10.653-7.177
		C20.922,25.192,22.192,23.234,24.015,22.043z"/>
	<radialGradient id="SVGID_2_" cx="28.3506" cy="28.7432" r="9.5129" gradientUnits="userSpaceOnUse">
		<stop  offset="0" style={{stopColor:"#00D6FF"}}/>
		<stop  offset="0.3193" style={{stopColor:"#00C1FF"}}/>
		<stop  offset="0.9782" style={{stopColor:"#008AFF"}}/>
		<stop  offset="1" style={{stopColor:"#0088FF"}}/>
	</radialGradient>
	<path fill="url(#SVGID_2_)" d="M28.112,22.747c-3.082,0-5.578,2.501-5.578,5.582s2.496,5.583,5.578,5.583
		c3.087,0,5.587-2.502,5.587-5.583S31.199,22.747,28.112,22.747z"/>
	<path fill="#FFFFFF" d="M28.427,25.491h-0.93v3.722l3.256,1.954l0.466-0.763l-2.792-1.656V25.491z"/>
</g>
</svg>


// WEBPACK FOOTER //
// ./src/Images/CallRecordSVG.js